import * as React from 'react';
const SvgRectangleArrowsOutward = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.333 5.917c0-.322.261-.584.584-.584H7.86a.583.583 0 0 1 0 1.167h-.536l1.337 1.338a.583.583 0 0 1-.824.824L6.5 7.325v.537a.583.583 0 0 1-1.167 0zm8.75 8.75a.583.583 0 0 0 .584-.583V12.14a.583.583 0 1 0-1.167 0v.537l-1.338-1.338a.583.583 0 1 0-.825.824l1.339 1.339h-.537a.583.583 0 1 0 0 1.167zm.413-9.162c.11.11.171.257.171.412v1.945a.583.583 0 1 1-1.167 0v-.537l-1.338 1.338a.583.583 0 0 1-.825-.826L12.676 6.5h-.537a.583.583 0 1 1 0-1.166h1.946c.154 0 .303.061.412.17m-9.163 8.579a.583.583 0 0 0 .584.583h1.945a.583.583 0 1 0 0-1.167h-.537l1.338-1.338a.583.583 0 1 0-.826-.824L6.5 12.675v-.536a.583.583 0 1 0-1.167 0zM3 4.75C3 3.784 3.784 3 4.75 3h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 15.25 17H4.75A1.75 1.75 0 0 1 3 15.25zm1.75-.583a.583.583 0 0 0-.583.583v10.5c0 .322.26.583.583.583h10.5a.583.583 0 0 0 .583-.583V4.75a.583.583 0 0 0-.583-.583z"
    />
  </svg>
);
export default SvgRectangleArrowsOutward;
